import script from "./RealName.vue?vue&type=script&setup=true&lang=js"
export * from "./RealName.vue?vue&type=script&setup=true&lang=js"

import "./RealName.vue?vue&type=style&index=0&id=a83e69b4&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a83e69b4"]])

export default __exports__